import { Controller } from "@hotwired/stimulus"

// A link that opens its target in the app-wide side panel instead of leaving the page, the same contract as a document
// or a ClickUp task (jane:open-panel): it is a real link to the full page, so cmd/ctrl/shift/middle click still opens
// that in a tab, and a plain click opens the panel.
//
//   a href="/tasks?list=449" data-controller="panel-link" data-action="click->panel-link#open"
//     data-panel-link-url-value="/task_lists/449/panel" data-panel-link-title-value="Series B" data-panel-link-label-value="Task list"
export default class extends Controller {
    static values = { url: String, title: String, icon: { type: String, default: "bi-check2-square" }, label: { type: String, default: "Task list" } }

    open(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1 || !this.urlValue) return

        event.preventDefault()
        window.dispatchEvent(new CustomEvent("jane:open-panel", {
            detail: { url: this.urlValue, title: this.titleValue || this.element.textContent.trim(), icon: this.iconValue, label: this.labelValue }
        }))
    }
}
